// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6081":"ccdd5ee90f6dbeca","9727":"b8c624b1c8f74e73"}[chunkId] + ".css";
};